import { create } from 'zustand';

import type { PosTransitionSnapshot, PosTransitionController } from './pos-transition-controller';

export const IDLE_POS_TRANSITION: PosTransitionSnapshot = {
  phase: 'idle',
  direction: null,
  secondsLeft: 5,
  progress: 0,
  message: null,
};

export const usePosTransitionStore = create<PosTransitionSnapshot>(() => IDLE_POS_TRANSITION);

// The boundary registers a live surface; the application runner owns its work.
export const usePosTransitionSurfaceStore = create<{ available: boolean }>(() => ({
  available: false,
}));

let controller: PosTransitionController | null = null;
export function bindPosTransitionController(next: PosTransitionController): () => void {
  controller = next;
  return () => {
    if (controller === next) controller = null;
  };
}

export const requestGoOffline = () => controller?.goOffline();
export const requestGoOnline = () => controller?.goOnline();
export const retryConnection = () => controller?.retry();
